<!--SolarToolResults--------------------------------------------------------------------------------------------------------------------------------------------------------->						

<template>
    <v-container grid-list-md text-center v-if="$store.state.pageSolarToolResultsActive">
        <v-layout wrap>
            <v-card color="grey lighten-5" class="mb-10" height="auto" width="1000">
                <v-card-title>
                    <v-text-field
                        :rules="ProjectNameRules"
                        v-model="$store.state.SolarToolNomProjet.Nom" 
                        label="Nom du projet (*) :"
                        placeholder="Veuillez sélectionner / encoder le nom du projet SVP."
                        filled
                    >
                    </v-text-field>
                </v-card-title>
                <v-data-table
                    :headers="$store.state.SolarToolDonneesProjetHeaders"
                    :items="$store.state.SolarToolDonneesProjet"
                    :items-per-page="10"
                    :single-select="true"
                    :dense = true
                    item-key="ID"
                    class="elevation-1"
                >
                    <template v-slot:top>
                        <v-toolbar
                            flat
                        >
                            <v-spacer></v-spacer>
                            <v-dialog
                                v-model="dialogEdit"
                                max-width="1200px"
                            >
                                <v-card>
                                    <v-card-title>
                                        <span class="text-h5">{{ formTitle }}</span>
                                    </v-card-title>
                                    <FormulaireResults></FormulaireResults>
                                    <v-card-actions>
                                        <v-spacer></v-spacer>
                                        <v-btn
                                            color="blue darken-1"
                                            text
                                            @click="closeEdit"
                                        >
                                            Annuler
                                        </v-btn>
                                        <v-btn v-if="
                                                $store.state.SolarToolAswJsonEditedItem.description != ''"
                                            color="blue darken-1"
                                            text
                                            @click="saveEdit"
                                        >
                                            Enregistrer
                                        </v-btn>
                                    </v-card-actions>
                                </v-card>
                            </v-dialog>
                            <v-dialog v-model="dialogDelete" max-width="500px">
                                <v-card>
                                    <v-card-title 
                                        class="text-h5">Voulez-vous supprimer cette ligne ?
                                    </v-card-title>
                                    <v-card-text>
                                        {{ $store.state.SolarToolAswJsonEditedItem.Reference }}
                                    </v-card-text>
                                    <v-card-actions>
                                        <v-spacer></v-spacer>
                                        <v-btn 
                                            color="blue darken-1" 
                                            text @click="closeDelete"
                                        >
                                                Annuler
                                        </v-btn>
                                        <v-btn 
                                            color="blue darken-1" 
                                            text 
                                            @click="deleteItemConfirm"
                                        >
                                            OK
                                        </v-btn>
                                        <v-spacer></v-spacer>
                                    </v-card-actions>
                                </v-card>
                            </v-dialog>
                        </v-toolbar>
                    </template>
                    <template v-slot:item.actions="{ item }">
                        <v-icon
                            small
                            class="mr-2"
                            @click="nameSelected(item)"
                        >
                            mdi-check
                        </v-icon>
                    </template>
                </v-data-table>
            </v-card>
            <v-flex
                v-if="$store.state.SolarToolNomProjet.Nom.length >= 3"
            >
                <v-card color="grey lighten-5" class="mb-10" height="auto">
                    <v-card-title>
                        <h5>Articles importés (à vérifier SVP) :</h5>
                        <v-spacer></v-spacer>
                        <v-text-field
                            v-model="$store.state.SolarToolAswJsonSearch"
                            append-icon="mdi-magnify"
                            label="Recherche"
                            single-line
                            hide-details>
                        </v-text-field>															
                    </v-card-title>
                    <v-data-table
                        :headers="$store.state.SolarToolAswJsonHeaders"
                        :items="$store.state.SolarToolAswJson.details"
                        :items-per-page="100"
                        :single-select="true"
                        :search="$store.state.SolarToolAswJsonSearch"
                        :dense = true
                        item-key="ID"
                        class="elevation-1"
                    >
                    <template v-slot:top>
                            <v-toolbar
                                flat
                            >
                                <v-spacer></v-spacer>
                                <v-dialog
                                    v-model="dialogEdit"
                                    max-width="1200px"
                                >
                                    <v-card>
                                        <v-card-title>
                                            <span class="text-h5">{{ formTitle }}</span>
                                        </v-card-title>
                                        <FormulaireResults></FormulaireResults>
                                        <v-card-actions>
                                            <v-spacer></v-spacer>
                                            <v-btn
                                                color="blue darken-1"
                                                text
                                                @click="closeEdit"
                                            >
                                                Annuler
                                            </v-btn>
                                            <v-btn v-if="
                                                    $store.state.SolarToolAswJsonEditedItem.description != ''"
                                                color="blue darken-1"
                                                text
                                                @click="saveEdit"
                                            >
                                                Enregistrer
                                            </v-btn>
                                        </v-card-actions>
                                    </v-card>
                                </v-dialog>
                                <v-dialog v-model="dialogDelete" max-width="500px">
                                    <v-card>
                                        <v-card-title class="text-h5">Voulez-vous supprimer cette ligne ?</v-card-title>
                                        <v-card-text>
                                            {{ $store.state.SolarToolAswJsonEditedItem.Reference }}
                                        </v-card-text>
                                        <v-card-actions>
                                            <v-spacer></v-spacer>
                                            <v-btn color="blue darken-1" text @click="closeDelete">Annuler</v-btn>
                                            <v-btn color="blue darken-1" text @click="deleteItemConfirm">OK</v-btn>
                                            <v-spacer></v-spacer>
                                        </v-card-actions>
                                    </v-card>
                                </v-dialog>
                            </v-toolbar>
                        </template>
                        <template v-slot:item.actions="{ item }">
                            <v-icon
                                small
                                class="mr-2"
                                @click="editItem(item)"
                            >
                                mdi-pencil
                            </v-icon>
                            <v-icon
                                small
                                class="mr-2"
                                @click="deleteItem(item)"
                            >
                                mdi-delete
                            </v-icon>
                        </template>
                    </v-data-table>
                </v-card>
                <v-row no-gutters>
                    <v-col cols="1" sm="1">
                        <v-dialog v-model="infoEsdec" width="1000"
                        v-if="$store.state.SolarToolIsCifCSV">
                        <template v-slot:activator="{ on, info }">
                            <v-btn icon color="blue" v-on="on" v-bind="info">
                                <i class="fas fa-info-circle"></i>
                            </v-btn>
                        </template>
                        <v-card>
                            <v-card-title class="headline grey lighten-2" primary-title>
                                SolarTool
                            </v-card-title>
                            <v-card-text>
                                <h3 class="mt-3">Veuillez coller dans ce champ le lien de partage du calculateur ESDEC</h3>
                                <v-flex xs12 sm12 class="ma-3">
                                    <p translate="no" class="blue--text p-2">Menu "Projets" -> "Partager ce projet" -> <i class="fas fa-copy"></i></p>
                                </v-flex>
                                <v-flex xs8 sm4>
                                    <v-img
                                        width="auto"
                                        src="../assets/esdec.png">
                                    </v-img>
                                </v-flex>
                                <v-card-text align="left">
                                </v-card-text>
                            </v-card-text>
                            <v-divider></v-divider>
                            <v-card-actions>
                                <v-spacer></v-spacer>
                                <v-btn color="primary" text @click="infoEsdec = false">
                                    Fermer
                                </v-btn>
                            </v-card-actions>
                        </v-card>
                    </v-dialog>

                    </v-col>
                    <v-col cols="11" sm="11">
                        <v-text-field
                        v-if="$store.state.SolarToolIsCifCSV"
                        :rules="EsdecRules"
                        v-model="$store.state.SolarToolEsdecLink" label="Lien de partage Esdec :"
                        filled
                    ></v-text-field>
                    </v-col>
                </v-row>
                <v-row no-gutters>
                    <v-col cols="1" sm="1">
                        <v-dialog v-model="infoNetstore" width="1000">
                            <template v-slot:activator="{ on, info }">
                                <v-btn icon color="blue" v-on="on" v-bind="info">
                                    <i class="fas fa-info-circle"></i>
                                </v-btn>
                            </template>
                            <v-card>
                                <v-card-title class="headline grey lighten-2" primary-title>
                                    SolarTool - info numéro de session Netstore
                                </v-card-title>
                                <v-card-text>
                                    <v-flex xs12 sm12>
                                        <v-img
                                            height="317"
                                            width="948"
                                            src="../assets/netstoresessionnumber.png">
                                        </v-img>
                                    </v-flex>
                                    <v-card-text align="left">
                                    </v-card-text>
                                </v-card-text>
                                <v-divider></v-divider>
                                <v-card-actions>
                                    <v-spacer></v-spacer>
                                    <v-btn color="primary" text @click="infoNetstore = false">
                                        Fermer
                                    </v-btn>
                                </v-card-actions>
                            </v-card>
                        </v-dialog>
                    </v-col>
                    <v-col cols="11" sm="11">
                        <v-text-field
                            :rules="NestoreSessionRules"
                            v-model="$store.state.SolarToolNetstoreSession" 
                            label="Numéro de session Netstore :"
                            filled
                        >
                        </v-text-field>
                    </v-col>
                </v-row>
                <v-flex xs12 sm12 >
                    <v-chip
                        v-if="$store.state.SolarToolMessagesErreur.length > 0"
                        class="ma-2"
                        closable
                        color="red"
                        text-color="white"
                        :model-value="true"
                        @click="openDialogErrors = true"
                    >
                        <v-icon
                                class="ma-2"
                            >
                                mdi-alert-circle-outline
                        </v-icon>
                        {{ $store.state.SolarToolMessagesErreurText }}
                    </v-chip>
                    <v-chip
                        v-if="$store.state.SolarToolMessagesAvertissement.length > 0"
                        class="ma-2"
                        closable
                        color="orange"
                        text-color="white"
                        :model-value="true"
                        @click="openDialogWarnings = true"
                    >
                        <v-icon
                            class="ma-2"
                        >
                            mdi-message-alert-outline
                        </v-icon>
                        {{ $store.state.SolarToolMessagesAvertissementText }}
                    </v-chip>
                    <v-chip
                        v-if="$store.state.SolarToolMessagesResultat.length > 0"
                        class="ma-2"
                        closable
                        color="green"
                        text-color="white"
                        :model-value="true"
                        @click="$store.state.SolarToolOpenDialogResult = true"
                    >
                        <v-icon
                            class="ma-2"
                        >
                            mdi-comment-check-outline
                        </v-icon>

                        Resultats
                    </v-chip>
                    <v-dialog v-model="openDialogErrors" width="3000">
                        <v-card>
                            <v-card-title class="headline red lighten-2" primary-title>
                                Erreurs :
                            </v-card-title>
                            <v-card-text
                                v-for="(message, index) in this.$store.state.SolarToolMessagesErreur"
                                :key="index"
                            >
                                <li>
                                    <b>{{ message }}</b>
                                </li>
                            </v-card-text>
                            <v-divider></v-divider>
                            <v-card-actions>
                                <v-spacer></v-spacer>
                                <v-btn color="primary" text @click="openDialogErrors = false">
                                    Ok
                                </v-btn>
                            </v-card-actions>
                        </v-card>
                    </v-dialog>
                    <v-dialog v-model="openDialogWarnings" width="1000">
                        <v-card>
                            <v-card-title class="headline orange lighten-2" primary-title>
                                Avertissements :
                            </v-card-title>
                            <v-card-text
                                v-for="(message, index) in this.$store.state.SolarToolMessagesAvertissement"
                                :key="index"
                            >
                                <li>
                                    <b>{{ message }}</b>
                                </li>
                            </v-card-text>
                            <v-divider></v-divider>
                            <v-card-actions>
                                Veuillez vérifier SVP !
                                <v-spacer></v-spacer>
                                <v-btn color="primary" text @click="openDialogWarnings = false">
                                    Ok
                                </v-btn>
                            </v-card-actions>
                        </v-card>
                    </v-dialog>
                </v-flex>
                <v-flex>
                    <v-btn 
                        v-if="!$store.state.SolarToolIsUploading && 
                        ($store.state.SolarToolNetstoreSession.length==32 ||
                        $store.state.SolarToolNetstoreSession.toLowerCase() == 'nonetstore') && 
                        $store.state.SolarToolNomProjet.Nom.length>=2 &&
                        ($store.state.SolarToolEsdecLink.length==83 || $store.state.SolarToolEsdecLink.length==0
                         || !$store.state.SolarToolIsCifCSV)"
                        @click="NetstoreQuotation" 
                        dark>
                        Créer le devis ASW
                    </v-btn>
                </v-flex>
                <v-dialog v-model="$store.state.SolarToolOpenDialogResult" width="1000">
                    <v-card>
                        <v-card-title class="headline green lighten-2" primary-title>
                            Résultats :
                        </v-card-title>
                        <v-card-text
                            v-for="(message, index) in this.$store.state.SolarToolMessagesResultat"
                            :key="index"
                        >
                            <li align="center">
                                <b>{{ message }}</b>
                            </li>
                        </v-card-text>
                        <v-divider></v-divider>
                        <v-card-actions>
                            <v-flex></v-flex>
                            <v-chip variant="outlined"
                                @click="copyToClipboard(this.$store.state.SolarToolquotationNumber)">
                                <h4 class="mr-2">{{ this.$store.state.SolarToolquotationNumber}}</h4>
                                <v-icon>mdi-content-copy</v-icon>
                            </v-chip>                   
                            <v-spacer></v-spacer>
                            <v-btn color="primary" text @click="$store.state.SolarToolOpenDialogResult = false">
                                Ok
                            </v-btn>
                        </v-card-actions>
                    </v-card>
                </v-dialog>
                <v-flex xs12 sm12>
                    <v-btn
                        class="ma-1" color="blue"
                        @click="SolarToolBack"
                        dark
                    >
                        Nouveau projet
                    </v-btn>
                </v-flex>
            </v-flex>
        </v-layout>
    </v-container>

</template>

<script>
    import ToolBoxMixins from './mixins/ToolBoxMixins.js';
    import FormulaireResults from './FormulaireResults';

	export default {
		name: "PageSolarToolResults",
		components: {
            FormulaireResults,
		},
		data: function () {
			return {
                infoEsdec: false,
                infoNetstore: false,
                dialogEdit: false,
                dialogDelete: false,
                openDialogErrors: false,
                openDialogWarnings: false,
                editedIndex: -1,
                formHasErrors: false,
                defaultItem: {
                    itemCode: '',
                    description: '',
                    quantity: '',
                    unit: '',
                },
                ProjectNameRules: [
                    (v) => !!v || "Champ obligatoire",
                    (v) =>
                    (v && v.length >= 3) ||
                    "Minimum 3 caractères",
                ],
                NestoreSessionRules: [
                    (v) => !!v || "Champ obligatoire",
                    (v) =>
                    (v && v.length == 32) ||
                    (v.toLowerCase() == 'nonetstore') ||
                    "Numéro invalide",
                ],
                EsdecRules: [
                    //(v) => !!v || "Champ obligatoire",
                    (v) =>
                    (v && v.length == 0 || (v && v.length == 83) &&
                    (v.toLowerCase().includes('https://calculator.eu.enstall.com/clone-shared/'))) ||
                    "Lien invalide",
                ],
           }
        },
		created() {
            this.$store.state.SolarToolMessagesErreur = [];
            this.$store.state.SolarToolMessagesAvertissement = [];
            this.$store.state.SolarToolMessagesResultat = [];
        },
        mixins: [
            ToolBoxMixins,
        ],
        computed: {
            formTitle() {
                return this.editedIndex === -1 ? "Nouvelle ligne" : "Modifier la ligne";
            },
        },
        watch: {
            dialogEdit(val) {
                val || this.closeEdit();
            },
            dialogDelete(val) {
                val || this.closeDelete();
            },
        },
		methods: {
            NetstoreQuotation(){
                this.sendToNetstore();
            },
            SolarToolBack() {
                this.solarToolResetData();
            },
            nameSelected(item) {
                this.$store.state.SolarToolNomProjet = Object.assign({}, item);
            },
            editItem(item) {
                this.editedIndex = this.$store.state.SolarToolAswJson.details.indexOf(item);
                this.$store.state.SolarToolAswJsonEditedItem = Object.assign({}, item);
                this.dialogEdit = true;
            },
            deleteItem(item) {
                this.editedIndex = this.$store.state.SolarToolAswJson.details.indexOf(item);
                this.$store.state.SolarToolAswJsonEditedItem = Object.assign({}, item);
                this.dialogDelete = true;
            },
            deleteItemConfirm() {
                this.$store.state.SolarToolAswJson.details.splice(this.editedIndex, 1);
                this.closeDelete();
            },
            closeEdit() {
                this.dialogEdit = false;
                this.$nextTick(() => {
                    this.$store.state.SolarToolAswJsonEditedItem = Object.assign({}, this.defaultItem);
                    this.editedIndex = -1;
                });
            },
            closeDelete() {
                this.dialogDelete = false;
                this.$nextTick(() => {
                    this.$store.state.SolarToolAswJsonEditedItem = Object.assign({}, this.defaultItem);
                    this.editedIndex = -1;
                });
            },
            saveEdit() {
                this.$store.state.SolarToolAswJson.details[this.editedIndex].description = this.$store.state.SolarToolAswJsonEditedItem.description;
                this.closeEdit();
            },
            copyToClipboard(textToCopy) {
                navigator.clipboard.writeText(textToCopy);
            },
        }
    }
</script>
